/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface UnifiedClassSessionBase
 */
export interface UnifiedClassSessionBaseOptional {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionBase
   */
  sessionDatetime?: Date;
}

export interface UnifiedClassSessionBase extends UnifiedClassSessionBaseOptional {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionBase
   */
  sessionDatetime?: Date;
}

export interface UnifiedClassSessionBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionBase
   */
  sessionDatetime?: Date;
  sessionDatetimeIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassSessionBase",
  function (model: UnifiedClassSessionBase) {
    if (typeof model.sessionDatetime == "string")
      model.sessionDatetime = new Date(model.sessionDatetime);
  },
);

export type UnifiedClassSessionBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  sessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var UnifiedClassSessionBaseMeta: UnifiedClassSessionBaseMetaI =
  {} as UnifiedClassSessionBaseMetaI;
UnifiedClassSessionBaseMeta = typeMeta("UnifiedClassSessionBase", {
  sessionDatetime: propertyMeta(
    "sessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = UnifiedClassSessionBaseMeta;

registerMeta(() => {});

export class UnifiedClassSessionBaseTracked implements UnifiedClassSessionBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  sessionDatetime__I?: Date = undefined;
  sessionDatetimeIsSet: boolean = false;
  set sessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.sessionDatetime__I = v;
      this.sessionDatetimeIsSet = true;
    } else {
      this.sessionDatetime__I = v || undefined;
      this.sessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDatetime() {
    return this.sessionDatetime__I;
  }
  constructor(
    config?: UnifiedClassSessionBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: UnifiedClassSessionBaseOptional,
    options?: AssignOptions,
  ): UnifiedClassSessionBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.sessionDatetime &&
      this.sessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDatetime = config.sessionDatetime;
      if (optionsRequired.unassign) this.sessionDatetimeIsSet = false;
      else this.sessionDatetimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassSessionBaseTrackedI {
    const cloned = {} as UnifiedClassSessionBaseTrackedI;
    if (
      this.sessionDatetimeIsSetDeep() &&
      this.sessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatetimeIsSet = true;
      cloned.sessionDatetime = this.sessionDatetime;
    } else {
      //cloned.sessionDatetimeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassSessionBaseTrackedI {
    if (!this.sessionDatetimeApplyFilter(filter))
      this.sessionDatetimeIsSet = false;

    return this;
  }
  sessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionBaseMeta.sessionDatetime,
      UnifiedClassSessionBaseMeta,
      this.sessionDatetime,
      this,
    );
  }
  sessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatetimeIsSet && this.sessionDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sessionDatetimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
